module.exports = __webpack_public_path__ + "img/instagram.7868de78.svg";